// Onboarding tour seen-flag helpers. Keyed per (tourId, version) so a
// future content change (e.g. add a new Studio capability) can be released
// as `version: 2` to reshow the tour without manually wiping every user's
// localStorage. Falls back gracefully when storage is unavailable
// (private-mode Safari, locked-down enterprise browsers) — the tour will
// re-appear each session in that case, which is preferable to throwing.

const STORAGE_PREFIX = 'floorplan.tour';

export function tourStorageKey(tourId, version = 1) {
  return `${STORAGE_PREFIX}.${tourId}.v${version}`;
}

function safeGet(key) {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    if (typeof localStorage === 'undefined') return false;
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function hasTourBeenSeen(tourId, version = 1) {
  const value = safeGet(tourStorageKey(tourId, version));
  return Boolean(value);
}

export function markTourSeen(tourId, version = 1) {
  return safeSet(tourStorageKey(tourId, version), new Date().toISOString());
}

// Test-only helper to drop a single tour's flag (and any older versions).
export function clearTour(tourId) {
  try {
    if (typeof localStorage === 'undefined') return;
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(`${STORAGE_PREFIX}.${tourId}.v`)) {
        toRemove.push(key);
      }
    }
    toRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore
  }
}
